var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tags-view-container",
      attrs: { id: "tags-view-container" },
    },
    [
      _c(
        "el-tabs",
        {
          attrs: { type: "card" },
          on: {
            "tab-click": _vm.handleTabSelector,
            "tab-remove": _vm.handleTabRemove,
          },
          nativeOn: {
            contextmenu: function ($event) {
              $event.preventDefault()
              return _vm.openMenu($event)
            },
            mouseup: function ($event) {
              if ("button" in $event && $event.button !== 1) {
                return null
              }
              return _vm.refreshSelectedTag($event)
            },
          },
          model: {
            value: _vm.tabValue,
            callback: function ($$v) {
              _vm.tabValue = $$v
            },
            expression: "tabValue",
          },
        },
        _vm._l(_vm.visitedViews, function (tag, index) {
          return _c("el-tab-pane", {
            key: tag.path,
            attrs: { label: tag.title, name: tag.path, closable: index > 0 },
          })
        }),
        1
      ),
      _vm._v(" "),
      _c(
        "ul",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.visible,
              expression: "visible",
            },
          ],
          staticClass: "contextmenu",
          style: { left: _vm.left + "px", top: _vm.top + "px" },
        },
        [
          _c("li", { on: { click: _vm.refreshSelectedTag } }, [_vm._v("刷新")]),
          _vm._v(" "),
          !_vm.isAffix(_vm.selectedTag)
            ? _c("li", { on: { click: _vm.closeSelectedTag } }, [
                _vm._v("关闭"),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("li", { on: { click: _vm.closeOthersTags } }, [
            _vm._v("关闭其他"),
          ]),
          _vm._v(" "),
          _c("li", { on: { click: _vm.closeAllTags } }, [_vm._v("关闭全部")]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }